/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/* eslint-disable shopify/jquery-dollar-sign-reference */
/**
 * Layout related methods
 * -----------------------------------------------------------------------------
 *
 * @namespace layout
 */

import enquire from 'enquire.js';
import detectIt from 'detect-it';
import tinycolor from 'tinycolor2';
import Flickity from 'flickity';
import videojs from 'video.js';
import 'videojs-youtube/dist/Youtube.min.js';
import 'video.js/dist/video-js.min.css';

var videoPlayer = null;

var layoutMethods = {
  data: function data() {
    return {
      scrollPosition: 0,
      isLogoLight: false,
      isOverlayVisible: false,
      isCartDrawerOpen: false,
      isMobileNavDrawerOpen: false,
      isSearchLayerOpen: false,
      isNewsletterPopupOpen: false,
      isShowPasswordMatchMessage: false,
      ispassWordMatched: false
    };
  },


  methods: {
    _initLayout: function _initLayout() {
      if (app.currentTemplate != 'collection') {
        window.addEventListener('scroll', app._checkScrollPos); // add scroll event listener
      }
      window.addEventListener('resize', app._initStickyHeader); // add resize event listener

      // make all images in RTE editor load via lazyload
      $('.rte img').addClass('lazyload');

      app._initBootstrapComponents();
      app._initNewsletterPopup();
      app._initStickyHeader();
      app._initCarousels();
      if (app.currentTemplate != 'collection') {
        app._checkScrollPos();
      }
      app._checkCurrencyElements();

      // init videos
      if ($('.video-js').length > 0) {
        videojs(document.querySelector('.video-js'));
      }
    },
    _initBootstrapComponents: function _initBootstrapComponents() {
      /* Bootstrap components that need to be initialized should be called here */
      // init popover
      $('[data-toggle="popover"]').popover();

      // cart dropdown popover
      $('[data-cart-dropdown]').popover({
        html: true,
        content: function content() {
          return $(this).next('[data-cart-dropdown-content]').html();
        }
      });

      // init tooltip but only for desktop
      if (!detectIt.hasTouch) {
        setTimeout(function () {
          $('[data-toggle="tooltip"]').tooltip();
        }, 100);
      }

      // make navigation drop-downs open on mouse hover instead of click
      $('.navbar a[data-toggle="dropdown"]').on('mouseenter', function (e) {
        var $dropdownLink = $(this).parent();
        var $dropdownMenu = $dropdownLink.find('.dropdown-menu');

        $dropdownLink.addClass('show');
        $dropdownMenu.addClass('show');

        $dropdownLink.on('mouseleave', function (e) {
          $(this).removeClass('show');
          $dropdownMenu.removeClass('show');
        });
      });

      // make also the top link clickable
      $('.navbar a[data-toggle="dropdown"]').on('click', function (e) {
        location.href = $(this).attr('data-href');
      });
    },
    _initNewsletterPopup: function _initNewsletterPopup() {
      var customerPosted = window.location.href.search('[?&]customer_posted=true') !== -1;
      var $newsletterPopup = $(app.selectors.newsletterPopup);
      var popupDelay = $newsletterPopup.data('popup-delay') * 1000;
      var daysUntil = $newsletterPopup.data('period-until');
      var newsletterPopupEnabled = $newsletterPopup.data('newsletter-enabled');
      var newsletterPopupStatus = app._getCookie('newsletter_popup_status');
      var today = new Date();
      var expirationDate = new Date();
      expirationDate.setDate(today.getDate() + daysUntil);
      var time = expirationDate.getTime();
      var expireTime = time + 1000 * 36000;
      expirationDate.setTime(expireTime);

      // after registration get the 'customer_posted' parameter from URL
      // show popup after successful registration
      // the popup will have the 'Thank you' message after registration redirection
      if (customerPosted) {
        app._toggleNewsletterPopup();
      }

      // do not show the popup if the disabled status cookie exists
      if (newsletterPopupStatus === 'disabled' || !newsletterPopupEnabled) {
        return;
      }

      setTimeout(function () {
        app._toggleNewsletterPopup();
      }, popupDelay);

      $(document).on('click', '[data-newsletter-close-btn]', function () {
        document.cookie = "newsletter_popup_status=disabled;expires=" + expirationDate.toGMTString() + ";path=/";
      });
    },
    _comparePassword: function _comparePassword(event) {
      app.isShowPasswordMatchMessage = true;
      var $targetEle = $(event.currentTarget);
      var ComaparePassword = $.trim($targetEle.val());
      var originPassword = $.trim($targetEle.closest('form').find('.customer-password').val());
      app.customerPassword = originPassword;
      app.confirmCustomerPassword = ComaparePassword;
      if (ComaparePassword.length == 0) {
        app.isShowPasswordMatchMessage = false;
        return false;
      }
      if (ComaparePassword == originPassword) {
        app.ispassWordMatched = true;
      } else {
        app.ispassWordMatched = false;
      }
    },
    _initStickyHeader: function _initStickyHeader() {
      var $siteHeader = $(app.selectors.siteHeader);
      var $headerSlider = $(app.selectors.headerSlider);
      var $mainNav = $siteHeader.find('nav');
      var $topBar = $siteHeader.find('[data-top-bar]');
      var navHeight = void 0;

      if ($topBar.length > 0) {
        navHeight = $mainNav.outerHeight() + $topBar.outerHeight();
      } else {
        navHeight = $mainNav.outerHeight();
      }

      if ($siteHeader.data('fixed-header')) {
        // boolean
        $('body:not(.alternate-homepage) #app').css('padding-top', navHeight);
      } else {
        $headerSlider.css('height', $headerSlider.outerHeight() - navHeight);
      }
    },


    /**
     * Window scroll info => update classes & elements
     */
    _checkScrollPos: function _checkScrollPos() {
      var $siteHeader = $(app.selectors.siteHeader);
      var $mainNav = $siteHeader.find('nav');
      var $topBar = $siteHeader.find('[data-top-bar]');
      var $navBgColor = $mainNav.css('backgroundColor');
      var isHeaderTransparent = $siteHeader.data('transparent-header');
      var isHomepage = $('body').hasClass('template-index');
      var windowScrollY = window.scrollY;
      var isDarkBg = void 0;
      var navHeight = void 0;

      if ($topBar.length > 0) {
        navHeight = $mainNav.outerHeight() + $topBar.outerHeight();
      } else {
        navHeight = $mainNav.outerHeight();
      }

      if (app.scrollPosition < windowScrollY && app.scrollPosition > navHeight) {
        // direction down
        $('body').removeClass('is-scrolled-top is-scrolled-up').addClass('is-scrolled-down');
        isDarkBg = tinycolor($navBgColor).isDark(); // returns boolean

        if (isDarkBg) {
          app.isLogoLight = true;
        } else {
          app.isLogoLight = false;
        }
      } else {
        // direction up
        $('body').removeClass('is-scrolled-top is-scrolled-down').addClass('is-scrolled-up');
        if (isHomepage && isHeaderTransparent) {
          $mainNav.removeClass('bg-transparent');
        }
        isDarkBg = tinycolor($navBgColor).isDark(); // returns boolean

        if (isDarkBg) {
          app.isLogoLight = false;
        }
      }

      if (windowScrollY <= navHeight) {
        // reached top
        $('body').removeClass('is-scrolled-up').addClass('is-scrolled-top');

        if (isHomepage && isHeaderTransparent) {
          $mainNav.addClass('bg-transparent');
          app.isLogoLight = true;
        }
      }

      if ($('#banner_1').length) {
        var layerId = $('.banner_1').attr('data-layerId');
        var layerName = $('.banner_1').attr('data-layerName');
        var layerCreative = $('.banner_1').attr('data-layerCreative');
        var layerPosition = $('.banner_1').attr('data-position');
        if (app.banner_1event === false) {
          dataLayer.push({
            event: 'promotionImpressions',
            ecommerce: {
              promoView: {
                promotions: [// Array of promoFieldObjects.
                {
                  id: layerId, // ID or Name is required.
                  name: layerName,
                  creative: layerCreative,
                  position: layerPosition
                }]
              }
            }
          });
          app.banner_1event = true;
        }
      }

      if ($('#banner_4').length) {
        // eslint-disable-next-line no-var
        var winTop = $(window).scrollTop();
        // eslint-disable-next-line no-var
        var winBottom = winTop + $(window).height();
        // eslint-disable-next-line no-var
        var elTop = $('#banner_4').offset().top;
        // eslint-disable-next-line no-var
        var elBottom = elTop + $('#banner_4').height();
        // eslint-disable-next-line no-var
        var Name = $('#banner_4').attr('data-layerName');
        // eslint-disable-next-line block-scoped-var
        if (winBottom > elTop && winTop < elBottom && app.banner_4event === false) {
          dataLayer.push({
            event: 'promotionImpressions',
            ecommerce: {
              promoView: {
                promotions: [// Array of promoFieldObjects.
                {
                  id: 'medium_banner_1', // ID or Name is required.
                  // eslint-disable-next-line block-scoped-var
                  name: Name,
                  creative: $('#banner_4').attr('data-layerCreative'),
                  position: 'M1'
                }]
              }
            }
          });
          app.banner_4event = true;
        }
      }
      if ($('#banner_5').length) {
        // eslint-disable-next-line no-var
        var winTop = $(window).scrollTop();
        // eslint-disable-next-line no-var
        var winBottom = winTop + $(window).height();
        // eslint-disable-next-line no-var
        var elTop = $('#banner_5').offset().top;
        // eslint-disable-next-line no-var
        var elBottom = elTop + $('#banner_5').height();
        // eslint-disable-next-line no-var
        var Name = $('#banner_5').attr('data-layerName');
        // eslint-disable-next-line block-scoped-var
        if (winBottom > elTop && winTop < elBottom && app.banner_5event === false) {
          dataLayer.push({
            event: 'promotionImpressions',
            ecommerce: {
              promoView: {
                promotions: [// Array of promoFieldObjects.
                {
                  id: 'medium_banner_2', // ID or Name is required.
                  // eslint-disable-next-line block-scoped-var
                  name: Name,
                  creative: $('#banner_5').attr('data-layerCreative'),
                  position: 'M2'
                }]
              }
            }
          });
          app.banner_5event = true;
        }
      }
      if ($('#banner_6').length) {
        var winTop = $(window).scrollTop();
        var winBottom = winTop + $(window).height();
        var elTop = $('#banner_6').offset().top;
        var elBottom = elTop + $('#banner_6').height();
        var Name = $('#banner_6').attr('data-layerName');
        // eslint-disable-next-line block-scoped-var
        if (elBottom <= winBottom && elTop >= winTop && app.banner_6event === false) {
          dataLayer.push({
            event: 'promotionImpressions',
            ecommerce: {
              promoView: {
                promotions: [// Array of promoFieldObjects.
                {
                  id: 'large_banner_1', // ID or Name is required.
                  // eslint-disable-next-line block-scoped-var
                  name: Name,
                  creative: $('#banner_6').attr('data-layerCreative'),
                  position: 'L'
                }]
              }
            }
          });
          app.banner_6event = true;
        }
      }
      if ($('#banner_7').length) {
        var winTop = $(window).scrollTop();
        var winBottom = winTop + $(window).height();
        var elTop = $('#banner_7').offset().top;
        var elBottom = elTop + $('#banner_7').height();
        var Name = $('#banner_7').attr('data-layerName');
        if (elBottom <= winBottom && elTop >= winTop && app.banner_7event === false) {
          dataLayer.push({
            event: 'promotionImpressions',
            ecommerce: {
              promoView: {
                promotions: [// Array of promoFieldObjects.
                {
                  id: 'carrusel_banner_1', // ID or Name is required.
                  // eslint-disable-next-line block-scoped-var
                  name: Name,
                  creative: $('#banner_7').attr('data-layerCreative'),
                  position: 'C'
                }]
              }
            }
          });
          app.banner_7event = true;
        }
      }
      if ($('#banner_8').length) {
        var winTop = $(window).scrollTop();
        var winBottom = winTop + $(window).height();
        var elTop = $('#banner_8').offset().top;
        var elBottom = elTop + $('#banner_8').height();
        var Name = $('#banner_8').attr('data-layerName');
        if (elBottom <= winBottom && elTop >= winTop && app.banner_8event === false) {
          dataLayer.push({
            event: 'promotionImpressions',
            ecommerce: {
              promoView: {
                promotions: [// Array of promoFieldObjects.
                {
                  id: 'rectangular_banner_1', // ID or Name is required.
                  // eslint-disable-next-line block-scoped-var 
                  name: Name,
                  creative: $('#banner_8').attr('data-layerCreative'),
                  position: 'R'
                }]
              }
            }
          });
          app.banner_8event = true;
        }
      }
      if ($('#banner_9').length) {
        var winTop = $(window).scrollTop();
        var winBottom = winTop + $(window).height();
        var elTop = $('#banner_9').offset().top;
        var elBottom = elTop + $('#banner_9').height();
        var Name = $('#banner_9').attr('data-layerName');
        if (elBottom <= winBottom && elTop >= winTop && app.banner_9event === false) {
          dataLayer.push({
            event: 'promotionImpressions',
            ecommerce: {
              promoView: {
                promotions: [// Array of promoFieldObjects.
                {
                  id: 'timer', // ID or Name is required.
                  // eslint-disable-next-line block-scoped-var
                  name: Name,
                  creative: $('#banner_9').attr('data-layerCreative'),
                  position: 'T'
                }]
              }
            }
          });
          app.banner_9event = true;
        }
      }

      if ($('.alternavite_homesections').length > 0) {
        $('.alternavite_homesections').each(function () {
          var winTop = $(window).scrollTop();
          var winBottom = winTop + $(window).height();
          var elTop = $(this).offset().top;
          var elBottom = elTop + $(this).height();

          var layerId = $(this).attr('data-layerId');
          var layerName = $(this).attr('data-layerName');
          var layerCreative = $(this).attr('data-layerCreative');
          var layerPosition = $(this).attr('data-layerposition');

          if (winBottom > elTop && winTop < elBottom && app.banner_new_event.includes(layerPosition) == false) {
            dataLayer.push({
              event: 'promotionImpressions',
              ecommerce: {
                promoView: {
                  promotions: [{
                    id: layerId, // ID or Name is required.
                    name: layerName,
                    creative: layerCreative,
                    position: layerPosition
                  }]
                }
              }
            });
            app.banner_new_event.push(layerPosition);
          }
        });
      }

      if ($('.main__banner--content').length > 0) {
        $('.main__banner--content').each(function () {
          var winTop = $(window).scrollTop();
          var winBottom = winTop + $(window).height();
          var elTop = $(this).offset().top;
          var elBottom = elTop + $(this).height();

          var layerId = $(this).attr('data-layerid');
          var layerName = $(this).attr('data-layer-name');
          var layerCreative = $(this).attr('data-layercreative');
          var layerPosition = $(this).attr('data-layer-position');

          if (winBottom > elTop && winTop < elBottom && app.banner_new_event.includes(layerPosition) == false) {
            dataLayer.push({
              event: 'promotionImpressions',
              ecommerce: {
                promoView: {
                  promotions: [{
                    id: layerId, // ID or Name is required.
                    name: layerName,
                    creative: layerCreative,
                    position: layerPosition
                  }]
                }
              }
            });
            app.banner_new_event.push(layerPosition);
          }
        });
      }

      if ($('.banner__beneficios_1').length > 0) {
        $('.banner__beneficios_1').each(function () {
          var winTop = $(window).scrollTop();
          var winBottom = winTop + $(window).height();
          var elTop = $(this).offset().top;
          var elBottom = elTop + $(this).height();

          var layerId = $(this).attr('data-layerid');
          var layerName = $(this).attr('data-layer-name');
          var layerCreative = $(this).attr('data-layercreative');
          var layerPosition = $(this).attr('data-layer-position');

          if (winBottom > elTop && winTop < elBottom && app.banner_new_event.includes(layerPosition) == false) {
            dataLayer.push({
              event: 'promotionImpressions',
              ecommerce: {
                promoView: {
                  promotions: [{
                    id: layerId, // ID or Name is required.
                    name: layerName,
                    creative: layerCreative,
                    position: layerPosition
                  }]
                }
              }
            });
            app.banner_new_event.push(layerPosition);
          }
        });
      }
      if ($('.banner__beneficios_2').length > 0) {
        $('.banner__beneficios_2').each(function () {
          var winTop = $(window).scrollTop();
          var winBottom = winTop + $(window).height();
          var elTop = $(this).offset().top;
          var elBottom = elTop + $(this).height();

          var layerId = $(this).attr('data-layerid');
          var layerName = $(this).attr('data-layer-name');
          var layerCreative = $(this).attr('data-layercreative');
          var layerPosition = $(this).attr('data-layer-position');

          if (winBottom > elTop && winTop < elBottom && app.banner_new_event.includes(layerPosition) == false) {
            dataLayer.push({
              event: 'promotionImpressions',
              ecommerce: {
                promoView: {
                  promotions: [{
                    id: layerId, // ID or Name is required.
                    name: layerName,
                    creative: layerCreative,
                    position: layerPosition
                  }]
                }
              }
            });
            app.banner_new_event.push(layerPosition);
          }
        });
      }
      if ($('.banner__beneficios_3').length > 0) {
        $('.banner__beneficios_3').each(function () {
          var winTop = $(window).scrollTop();
          var winBottom = winTop + $(window).height();
          var elTop = $(this).offset().top;
          var elBottom = elTop + $(this).height();

          var layerId = $(this).attr('data-layerid');
          var layerName = $(this).attr('data-layer-name');
          var layerCreative = $(this).attr('data-layercreative');
          var layerPosition = $(this).attr('data-layer-position');

          if (winBottom > elTop && winTop < elBottom && app.banner_new_event.includes(layerPosition) == false) {
            dataLayer.push({
              event: 'promotionImpressions',
              ecommerce: {
                promoView: {
                  promotions: [{
                    id: layerId, // ID or Name is required.
                    name: layerName,
                    creative: layerCreative,
                    position: layerPosition
                  }]
                }
              }
            });
            app.banner_new_event.push(layerPosition);
          }
        });
      }

      if ($('.desktop_flash_1').length > 0) {
        $('.desktop_flash_1').each(function () {
          var winTop = $(window).scrollTop();
          var winBottom = winTop + $(window).height();
          var elTop = $(this).offset().top;
          var elBottom = elTop + $(this).height();

          var layerId = $(this).attr('data-layerid');
          var layerName = $(this).attr('data-layer-name');
          var layerCreative = $(this).attr('data-layercreative');
          var layerPosition = $(this).attr('data-layer-position');

          if (winBottom > elTop && winTop < elBottom && app.banner_new_event.includes(layerPosition) == false) {
            dataLayer.push({
              event: 'promotionImpressions',
              ecommerce: {
                promoView: {
                  promotions: [{
                    id: layerId, // ID or Name is required.
                    name: layerName,
                    creative: layerCreative,
                    position: layerPosition
                  }]
                }
              }
            });
            app.banner_new_event.push(layerPosition);
          }
        });
      }

      if ($('.desktop_flash_2').length > 0) {
        $('.desktop_flash_2').each(function () {
          var winTop = $(window).scrollTop();
          var winBottom = winTop + $(window).height();
          var elTop = $(this).offset().top;
          var elBottom = elTop + $(this).height();

          var layerId = $(this).attr('data-layerid');
          var layerName = $(this).attr('data-layer-name');
          var layerCreative = $(this).attr('data-layercreative');
          var layerPosition = $(this).attr('data-layer-position');

          if (winBottom > elTop && winTop < elBottom && app.banner_new_event.includes(layerPosition) == false) {
            dataLayer.push({
              event: 'promotionImpressions',
              ecommerce: {
                promoView: {
                  promotions: [{
                    id: layerId, // ID or Name is required.
                    name: layerName,
                    creative: layerCreative,
                    position: layerPosition
                  }]
                }
              }
            });
            app.banner_new_event.push(layerPosition);
          }
        });
      }

      app.scrollPosition = windowScrollY;
    },
    _initCarousels: function _initCarousels() {
      var $carousel = $(app.selectors.carousel);
      var videoPlayerSlider = void 0;

      $carousel.each(function (index, el) {
        var flkty = Flickity.data(el); // pass in the element, $element[0], not the jQuery object

        if (typeof flkty === 'undefined') {
          return;
        }

        var totalSlides = flkty.cells.length;
        var selectedSlide = flkty.selectedElement;
        var slideType = $(selectedSlide).data('slide-type');

        if (totalSlides === 1) {
          $(el).addClass('hide-nav-ui');
        }

        flkty.on('settle', function () {
          selectedSlide = flkty.selectedElement;
          slideType = $(selectedSlide).data('slide-type');
          checkVideo(slideType);
        });

        flkty.on('change', function (index) {
          var currentSlider = flkty.selectedElement;
          if ($(currentSlider).attr('data-layerId') != undefined && $(currentSlider).attr('data-layerId').indexOf('homepage_slider_2') > -1 && app.banner_2event === false) {
            var layerId = $(currentSlider).attr('data-layerId');
            var layerName = $(currentSlider).attr('data-layerName');
            var layerCreative = $(currentSlider).attr('data-layerCreative');
            var layerPosition = $(currentSlider).attr('data-position');
            dataLayer.push({
              event: 'promotionImpressions',
              ecommerce: {
                promoView: {
                  promotions: [// Array of promoFieldObjects.
                  {
                    id: layerId, // ID or Name is required.
                    name: layerName,
                    creative: layerCreative,
                    position: layerPosition
                  }]
                }
              }
            });
            app.banner_2event = true;
          } else if ($(currentSlider).attr('data-layerId') != undefined && $(currentSlider).attr('data-layerId').indexOf('homepage_slider_3') > -1 && app.banner_3event === false) {
            var _layerId = $(currentSlider).attr('data-layerId');
            var _layerName = $(currentSlider).attr('data-layerName');
            var _layerCreative = $(currentSlider).attr('data-layerCreative');
            var _layerPosition = $(currentSlider).attr('data-position');
            dataLayer.push({
              event: 'promotionImpressions',
              ecommerce: {
                promoView: {
                  promotions: [// Array of promoFieldObjects.
                  {
                    id: _layerId, // ID or Name is required.
                    name: _layerName,
                    creative: _layerCreative,
                    position: _layerPosition
                  }]
                }
              }
            });
            app.banner_3event = true;
          } else if ($(currentSlider).attr('data-layerId') != undefined && $(currentSlider).attr('data-layerId').indexOf('homepage_slider_4') > -1 && app.banner_10event === false) {
            var _layerId2 = $(currentSlider).attr('data-layerId');
            var _layerName2 = $(currentSlider).attr('data-layerName');
            var _layerCreative2 = $(currentSlider).attr('data-layerCreative');
            var _layerPosition2 = $(currentSlider).attr('data-position');
            dataLayer.push({
              event: 'promotionImpressions',
              ecommerce: {
                promoView: {
                  promotions: [// Array of promoFieldObjects.
                  {
                    id: _layerId2, // ID or Name is required.
                    name: _layerName2,
                    creative: _layerCreative2,
                    position: _layerPosition2
                  }]
                }
              }
            });
            app.banner_10event = true;
          }
          if (videoPlayerSlider) {
            videoPlayerSlider.pause();
          }
        });
        function checkVideo(slideType) {
          if (slideType !== 'video') {
            return;
          }
          videoPlayerSlider = videojs($(selectedSlide).find('.video-js')[0]);
          videoPlayerSlider.play();
        }

        checkVideo(slideType);
        flkty.resize();
        app._triggerResize();
      });
    },
    _initVideo: function _initVideo(selectedSlide) {
      var $selectedVideo = $(selectedSlide).find('[data-video-slide]');
      var selectedVideoId = $selectedVideo.data('video-id');

      if (!selectedVideoId) {
        return;
      }

      function onPlayerReady(e) {
        e.target.setPlaybackQuality('hd720');
        e.target.mute();
        e.target.playVideo();
      }

      function onPlayerStateChange(e) {
        if (e.data === YT.PlayerState.ENDED) {}
      }

      enquire.register('screen and (min-width: 720px)', {
        match: function match() {
          YouTubeIframeLoader.load(function (YT) {
            videoPlayer = new YT.Player($selectedVideo[0], {
              videoId: selectedVideoId,
              width: '100%',
              height: '100%',
              playerVars: {
                enablejsapi: 1,
                autoplay: 1,
                loop: 1,
                playlist: selectedVideoId, // otherwise loop will not work
                rel: 0,
                controls: 0,
                showinfo: 0,
                modestbranding: 0,
                disablekb: 1
                // 'start': 0,
                // 'end': 335,
              },
              events: {
                onReady: onPlayerReady,
                onStateChange: onPlayerStateChange
              }
            });
          });
        },
        unmatch: function unmatch() {
          if (videoPlayer) {
            videoPlayer.destroy();
          }
        }
      });
    },


    /**
     * Event when variant quantity selector changes
     */
    _updateQty: function _updateQty(event) {
      var $qtyEl = $(event.currentTarget).parentsUntil(app.selectors.qtyContainer).find(app.selectors.qtyInput);
      var qtyValue = $qtyEl.val();
      var $item = $(event.currentTarget).closest(app.selectors.cartItem);
      var variantId = $item.data('variant-id');
      var cartProduct = app.cart.items.find(function (x) {
        return x.variant_id === variantId;
      });
      var productCartLimit = $item.data('cart-limit');

      if ($(event.currentTarget).data('qty-decrease') !== undefined) {
        if (parseFloat(qtyValue) >= 2) {
          qtyValue = parseFloat(qtyValue) - 1;
        }
      } else if ($(event.currentTarget).data('qty-increase') !== undefined) {
        qtyValue = parseFloat(qtyValue) + 1;

        // check if item has product limit assigned
        if (app.currentTemplate === 'cart' && app._productHasCartLimit(qtyValue, productCartLimit)) {
          return;
        }
      }

      $qtyEl.val(qtyValue);
    },


    /**
     * Event for toggling the cart drawer
     *
     */
    _toggleCartDrawer: function _toggleCartDrawer() {
      if (app.currentTemplate === 'cart') {
        return;
      }

      var $siteOverlay = $(app.selectors.siteOverlay);
      var cartType = $(app.selectors.siteHeader).data('cart-type');

      // stop parsing if cart type is not set to 'drawer'
      if (cartType !== 'cart_drawer') {
        return;
      }

      if (!app.isCartDrawerOpen) {
        // open drawer
        app.isOverlayVisible = true;
        app._lockScroll();
        app.isSearchLayerOpen = false;

        // re-init tooltips but only for desktop
        if (!detectIt.hasTouch) {
          $('[data-toggle="tooltip"]').tooltip();
        }
      } else {
        app.isOverlayVisible = false;
        app._unlockScroll();
      }

      // toggle the status data
      app.isCartDrawerOpen = !app.isCartDrawerOpen;

      $siteOverlay.on('click', function () {
        if (app.isSearchLayerOpen) {
          return;
        }
        app._toggleCartDrawer();
      });

      $(document).on('keydown', function (e) {
        // close drawer
        if (!app.isCartDrawerOpen) {
          return;
        }
        e = e || window.event;
        if (e.keyCode === 27) {
          app._toggleCartDrawer();
        }
      });
    },


    /**
     * Event for toggling the mobile menu drawer
     *
     */
    _toggleMobileNavDrawer: function _toggleMobileNavDrawer() {
      var $siteOverlay = $(app.selectors.siteOverlay);

      if (!app.isMobileNavDrawerOpen) {
        // open drawer
        app.isOverlayVisible = true;
        app.isSearchLayerOpen = false;
        app._lockScroll();
        app.isFilterNavDrawerOpen = false;
        $('.search-reveal,[data-site-overlay]').css('top', 0);
        $('.site-header').removeClass('active');
      } else {
        app.isOverlayVisible = false;
        app._unlockScroll();
      }

      // toggle the status data
      app.isMobileNavDrawerOpen = !app.isMobileNavDrawerOpen;

      $siteOverlay.on('click', function () {
        if (!app.isMobileNavDrawerOpen) {
          return;
        }
        app._toggleMobileNavDrawer();
      });
    },


    /**
     * Event for toggling the search layer
     *
     */
    _toggleSearch: function _toggleSearch() {
      var headerBox = $('.site-header').outerHeight();
      var $siteOverlay = $(app.selectors.siteOverlay);

      var $searchLayer = $(app.selectors.searchLayer);
      var searchType = $searchLayer.data('search-type');
      var $inputSearch = $searchLayer.find('#searchInput');

      if (!app.isSearchLayerOpen) {
        $inputSearch.val('');
        app._lockScroll();
        app.isMobileNavDrawerOpen = false;

        $('.search-reveal, [data-site-overlay]').css('top', headerBox);
        $('.site-header').addClass('active');
        if (searchType === 'full_screen') {
          $('header, footer, section').addClass('filter-blur').css('opacity', '0.5');
          $('[data-product-toolbar-mobile]').hide();
        } else {
          app.isOverlayVisible = true;
        }

        setTimeout(function () {
          $inputSearch.focus();
        }, 500);
      } else {
        $inputSearch.blur();
        app._unlockScroll();

        $('.search-reveal, [data-site-overlay]').css('top', '0');
        $('.site-header').removeClass('active');

        if (searchType === 'full_screen') {
          $('header, footer, section').removeClass('filter-blur').css('opacity', '1');
          $('[data-product-toolbar-mobile]').show();
        } else {
          app.isOverlayVisible = false;
        }
      }

      // toggle the status data
      app.isSearchLayerOpen = !app.isSearchLayerOpen;

      $(document).on('keydown', function (e) {
        // close drawer
        if (!app.isSearchLayerOpen) {
          return;
        }
        e = e || window.event;
        if (e.keyCode === 27 && app.isSearchLayerOpen) {
          app._toggleSearch();
        }
      });

      // overlay on click to close search
      $siteOverlay.on('click', function () {
        if (!app.isSearchLayerOpen) {
          return;
        }
        app._toggleSearch();
      });
    },


    /**
     * Event for toggling the newsletter popup
     *
     */
    _toggleNewsletterPopup: function _toggleNewsletterPopup() {
      if (!app.isNewsletterPopupOpen) {
        app._lockScroll();
        app.isOverlayVisible = true;
      } else {
        app._unlockScroll();
        app.isOverlayVisible = false;
      }

      // toggle the status data
      app.isNewsletterPopupOpen = !app.isNewsletterPopupOpen;
    },


    /**
     * Lock window scroll
     *
     */
    _lockScroll: function _lockScroll() {
      $('html').css('overflow', 'hidden');

      $(document).on('touchmove', function (e) {
        if (!$(e.target).closest('[data-touch-moveable]').length) {
          e.preventDefault();
        }
      });
    },


    /**
      * Unlock window scroll
      *
      */
    _unlockScroll: function _unlockScroll() {
      $('html').css('overflow', 'auto');
      $(document).unbind('touchmove');
    },
    _changeCurrency: function _changeCurrency() {
      var $currencyForm = $('[data-currency-selector]');
      $currencyForm[0].submit();
    }
  }
};

export default layoutMethods;